import { render, staticRenderFns } from "./StatsContainer.vue?vue&type=template&id=60fccd27&scoped=true&"
import script from "./StatsContainer.vue?vue&type=script&lang=js&"
export * from "./StatsContainer.vue?vue&type=script&lang=js&"
import style0 from "./StatsContainer.vue?vue&type=style&index=0&id=60fccd27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fccd27",
  null
  
)

export default component.exports